<template>
  <div class="form">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <h1 align="center" style="text-decoration: underline overline">
      JRB PENERIMAAN BULAN SEBELUMNYA
    </h1>

    <v-text-field
      outlined
      dense
      rounded
      v-model="HID"
      label="HID"
      :rules="rules"
      width="20px"
      disabled
    ></v-text-field>

    <!-- DATATABLE  -->
    <v-card>
      <v-card-title>
        Senarai
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

         <v-spacer></v-spacer>
          <v-btn
          color="error"
          small
          @click="dialogPengesahan=true;"
          >
            Padam
          </v-btn>

      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataImbanganHIS"
        :search="search"
        class="ml-3 mr-3"
        @click:row="handleClick"
        :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
      ></v-data-table>
    </v-card>

    <v-card>
      <!-- <v-card-title> <strong>HELAIAN IMBANGAN </strong><br /> </v-card-title> -->
      <v-card-text>

        <v-form ref="form" v-model="valid" lazy-validation :disabled="disabledInput">

          <v-row>
            <v-col>
              <strong>PENERIMAAN BULAN SEBELUMNYA (INCS 09) </strong><br />
            </v-col>
          </v-row>

          <v-col>
          </v-col>

          <v-row >
            <v-col cols="20" sm="3" md="5">
              S112. Wang yang dikeluarkan dari simpanan terdahulu
            

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-alert-circle
                    </v-icon>
                  </template>
                  <span>(Cth: Bank, Tabung Haji, i-Lestari, i-Sinar, Tabung Amanah, dll)</span>
                </v-tooltip>
            </v-col>

            <v-col cols="1">  <strong>[INCS9a]</strong><br />
            </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JUM9a"
                label="RM"
                min="0"
                maxlength="7"
                hint="Sebulan"
                persistent-hint
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              S113. Jualan bon, saham dan jaminan<br />
            </v-col>

            <v-col cols="1"> <strong>[INCS9b]</strong><br /></v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JUM9b"
                label="RM"
                min="0"
                maxlength="7"
                hint="Sebulan"
                persistent-hint
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              S114. Pinjaman dari bank, koperasi dan orang perseorangan<br
            /></v-col>

            <v-col cols="1"> <strong>[INCS9c]</strong><br /></v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JUM9c"
                label="RM"
                min="0"
                maxlength="7"
                hint="Sebulan"
                persistent-hint
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              S115. Sewa beli - pinjaman yang diperoleh<br
            /></v-col>

            <v-col cols="1"> <strong>[INCS9d]</strong><br /></v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JUM9d"
                label="RM"
                min="0"
                maxlength="7"
                hint="Sebulan"
                persistent-hint
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              S116. Penerimaan lain<br
            /></v-col>

            <v-col cols="1"> <strong>[INCS9e]</strong><br /></v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="JUM9e"
                label="RM"
                min="0"
                maxlength="7"
                hint="Sebulan"
                persistent-hint
                @keypress="isNumber($event)"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row>
            <v-col cols="20" sm="3" md="5">
              S117. Jumlah penerimaan bulan sebelumnya<br
            /></v-col>

            <v-col cols="1"> <strong>[INCS09]</strong></v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="INCS09"
                label="RM"
                min="0"
                maxlength="7"
                hint="Sebulan"
                persistent-hint
                @keypress="isNumber($event)"
                disabled
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row> </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateIMBANGAN()"
    >
      Kemaskini
    </v-btn>
     <!-- <v-btn
      text
      color="primary"
      v-show="butangPadam"
      :value="popUpALert"
    >
      Padam
    </v-btn> -->
</v-card-actions>
    </v-card>

    <v-alert prominent type="error" :value="popUpALert">
      <v-row align="center" class="mb-2">
        <v-col class="grow"> Adakah anda pasti untuk padam? </v-col>
        <v-col class="shrink">
          <v-btn @click="padam('1')" class="mb-3">Ya</v-btn>
          <v-btn @click="padam('2')">Tidak</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" height="200">
      <v-card>
        <v-alert dense outlined color="#C51162" type="error">
          <strong>{{ errMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>


<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
    
  </div>
</template>
<script>
import axios from "axios";
//import axios from "../../plugins/axios";
import i18n from "@/i18n";

//////////////////////////import services///////////////////
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import lookupField from "@/services/lookupField";
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
  
  async beforeMount() {
    var dataHID = localStorageData.getHIDdata();

    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB = dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.Bulan = dataHID.BULAN;
    this.Tahun = dataHID.TAHUN;

    this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
    this.NOAIR = this.currNOAIRData.NOAIR;

    this.getData(); //dapatkan data based on HID


  },

  data: () => ({
    updateButton: true,
    saveButton: false,
    dialog: false,
    successDialog: false,
    errorDialog: false,
    successMessage: "",
    errMessage: "",
    disabledInput : false,
    message: "Saving Data",
    popUpALert: false,
    search: "",
    butangSimpan: true,
    butangKemaskini: false,
    butangPadam: false,
    dialogPengesahan: false,
    /////////////////////data declaration//////////////////////////
    HID: '',
    JUM9a: 0,
    JUM9b: 0,
    JUM9c: 0,
    JUM9d: 0,
    JUM9e: 0,

    dataImbanganHIS: [],
   
    headers: [
      {
        text: "NOAIR",
        align: "start",
        sortable: false,
        value: "NOAIR",
      },

      { text: "HID", value: "HID" },
      { text: "INCS 9a", value: "JUM9a" },
      { text: "INCS 9b", value: "JUM9b" },
      { text: "INCS 9c", value: "JUM9c" },
      { text: "INCS 9d", value: "JUM9d" },
      { text: "INCS 9e", value: "JUM9e" },
      { text: "INCS 09", value: "INCS09" },
     
    ],

    ///////////link untuk ke page/////////////////////
     breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'JRB Penerimaan Bulan Sebelumnya',
          disabled: true,
          href: 'IMBANGAN',
        },
    ],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
  }),

  methods: {
    getUnits: function (a) {
      alert(`${a}`);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
   
    async simpan() {
      if (this.$refs.form.validate()) {
        this.dialog = true;
        setTimeout(() => (this.dialog = false), 2000);

        try {
          const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/IMBANGAN`,
            {
              HID: this.HID,
              NOAIR: this.NOAIR,
              JUM9a: this.JUM9a,
              JUM9b: this.JUM9b,
              JUM9c: this.JUM9c,
              JUM9d: this.JUM9d,
              JUM9e: this.JUM9e,
              INCS09: this.INCS09,
                 
            }
          );
          this.res = res.data;
          this.successDialog = true;
          this.disabledInput = true,
          setTimeout(() => (this.successDialog = false), 2000);
          this.successMessage = "Data Disimpan!";
          this.getData();
          this.reset();
          setTimeout(() => this.goTo(), 1000);
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Simpan : " + error;
        }
      } else {
        window.scrollTo(0, 0);
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Please fill in the field!";
      }
     },

    async updateIMBANGAN(){
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/updateIMBANGAN`, {
                
              HID: this.HID,
              NOAIR: this.NOAIR,
              JUM9a: this.JUM9a,
              JUM9b: this.JUM9b,
              JUM9c: this.JUM9c,
              JUM9d: this.JUM9d,
              JUM9e: this.JUM9e,
              INCS09: this.INCS09,
              
              })
                this.res = res.data;
                this.butangKemaskini = false;
                this.successDialog = true;
                this.disabledInput = true,
                this.getData()
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Berjaya Dikemaskini!';
                this.reset();
                setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }

        
      },

    async padam(val) {
    
      if (val == 0) {
        this.popUpALert = true;
      } else if (val == 1) {
        try {
          ///////////tunjukkan alert padam////////////
          //this.popUpALert = false;
          ////send delete to API///////
          if (this.$refs.form.validate()) {
            const res = await axios.post(
              `${process.env.VUE_APP_API_URL}/JR5/deleteIMBANGAN`,
              {
                HID: this.HID,
                NOAIR: this.NOAIR,
              }
            );
            this.res = res.data;
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Deleted!";
            this.saveButton = false;
            this.updateButton = true;
            //this.popUpALert = false;
            this.reset();
            this.getData();
          } else {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = "Please Fill In the field";
          }
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Padam : " + error;
        }
      } else if (val == 2) {
        this.popUpALert = false;
      }
    },

    
      async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/deleteIMBANGAN`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "PER9"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },

    async getData() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getIMBANGAN?HID=`+this.HID+`&NOAIR=`+this.NOAIR,{
          });
        var dataz = res.data.data;
        this.dataImbanganHIS = dataz;
      } catch (error) {
        //console.log(error)
        
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

    

    handleClick(row) {
      this.butangSimpan = false;
      this.butangKemaskini = true;
      this.disabledInput = false;

      this.HID = row.HID;
      this.NOAIR = row.NOAIR;
      this.JUM9a = row.JUM9a;
      this.JUM9b = row.JUM9b;
      this.JUM9c = row.JUM9c;
      this.JUM9d = row.JUM9d;
      this.JUM9e = row.JUM9e;
      this.INCS09 = row.INCS09;

     
    },

    goTo() {
      this.$router.push({ name: "IMBANGAN" });
    },
    goBack() {
      this.$router.push({ name: "PERBELANJAAN" });
    },
    kiraINCS09() {
      var total = 0;
      total =
        Number(this.JUM9a) +
        Number(this.JUM9b) +
        Number(this.JUM9c) +
        Number(this.JUM9d) +
        Number(this.JUM9e);
      this.INCS09 = total;
    },
    
    goToBorang(val) {
      var selectedSektor = val.id;
      if (selectedSektor == 1) {
        this.$router.push({ name: "hk2" });
      }
      if (selectedSektor == 2) {
        this.$router.push({ name: "hk3" });
      }
      if (selectedSektor == 3) {
        this.$router.push({ name: "hk4" });
      }
      if (selectedSektor == 4) {
        this.$router.push({ name: "hk5" });
      }
      if (selectedSektor == 5) {
        this.$router.push({ name: "hk6" });
      }
    },
    isNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  watch:{
    dataImbanganHIS(){
      if(this.dataImbanganHIS.length > 0){
        this.butangSimpan = false;
        this.disabledInput = true;
      }else{
        this.butangSimpan = true;
        this.disabledInput = false;
      }
    }
  
  },
  computed: {
    INCS09: function () {
      var total = 0;
      total =
        Number(this.JUM9a) +
        Number(this.JUM9b) +
        Number(this.JUM9c) +
        Number(this.JUM9d) +
        Number(this.JUM9e);
      return total;
    }
  },
};
</script>

<style>
#app {
  background: url("~@/assets/HIES.jpg") no-repeat center center fixed !important;
  background-size: cover;
}
</style>


